import { useState, useContext } from "react";
import { cerrarSession, hideSideBarDesktop, validaGetStatus } from "../utils/funciones";
import { mensajeSimple, modalCargando } from "../components/ui/sweetAlerts";
import { DataContext } from "../contextData/contextData";
import { getUno } from "../api/apis";
import Swal from "sweetalert2";

export const useIndex = () => {
  const { setUno, setDataObj } = useContext(DataContext);
  const [arrData, setArrData] = useState([]);

  const traerData = async () => {
    modalCargando("Cargando datos...");
    const resp = await getUno("personasporjefe", null, null);
    hideSideBarDesktop();
    
    if (!validaGetStatus(resp)) {
      cerrarSession();
    }

    const { COLABORADORES, JEFE_DIRECTO, EJECUTIVO_RRHH } = resp.data.data;

    const COLABORADORES_MODIFICADOS = COLABORADORES.map((e) => ({
      ...e,
      REEO_NOMBRE_COMPLETO: e.REEO_NOMBRES + " " + e.REEO_APELLIDO_PATERNO + " " + e.REEO_APELLIDO_MATERNO,
    }))
     .sort((a, b) => a.REEO_NOMBRES.localeCompare(b.REEO_NOMBRES));

    setArrData(COLABORADORES_MODIFICADOS);

    setDataObj({ jefe_directo: JEFE_DIRECTO, ejecutivo_rrhh: EJECUTIVO_RRHH });

    if (resp.status !== 200) {
      mensajeSimple("error", "Error al traer data");
      return;
    }
    setTimeout(() => {
      Swal.close();
    }, 500);
  };

  const filtrarUno = (obj) => {
    if (obj) {
      const selec = arrData.filter(e => e["REEO_CODIGO_SAP"] === obj.value);
      setUno(selec[0]);
      return;
    }
    setUno(undefined);
  }

  const formatFecha = (txt) => {
    const fechaStr = txt.toString();

    const anio = fechaStr.substring(0, 4);
    const mes = fechaStr.substring(4, 6);
    const dia = fechaStr.substring(6, 8);

    return `${dia}-${mes}-${anio}`;
  }

  const objTipoContrato = {
    "01": "Indefinido",
    "02": "Fijo",
  }

  return {
    traerData, filtrarUno, objTipoContrato, arrData, formatFecha, setDataObj
  }
}